import {Error, ValidationResult, Validator} from '@/type/validation/result';
import {期限切れ破棄破損型} from '@/type/custom/otaru/destroy/otaruDestroy';
import {必須入力, 小数制限, 日付書式} from '@/type/validation/validator';
import moment from 'moment';

export default class 期限切れ破棄破損チェッカー {
  単項目チェック結果: Error[] = [];

  constructor(target: 期限切れ破棄破損型) {
    const 期限切れ破棄破損チェック = new ValidationResult(期限切れ破棄破損Validators);
    期限切れ破棄破損チェック.validate(target);
    this.単項目チェック結果 = 期限切れ破棄破損チェック.getErrors;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0;
  }

  errorMessages(): string[] {
    return this.単項目チェック結果
      .map((value) => `${value.message}`);
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => error.name === name);
  }
}

const 処理日Validator = {
  name: '処理日',
  constraints: [
    {method: 必須入力, message: '処理日は入力が必須です'},
    {method: 日付書式, message: '処理日の書式を正しく入力してください'},
  ],
};

const 商品コードValidator = {
  name: '商品コード',
  constraints: [
    {method: 必須入力, message: '商品が選択されていません'},
  ],
};

const バラ数Validator = {
  name: 'バラ数',
  constraints: [
    {method: 必須入力, message: '数量は入力が必須です'},
    {method: (value: number) => 小数制限(value, 8, 3), message: '数量は整数部8桁,小数以下3桁以内で入力してください'},
  ],
};

const 単価Validator = {
  name: '単価',
  constraints: [
    {method: 必須入力, message: '単価は入力が必須です'},
    {method: (value: number) => 小数制限(value, 7, 3), message: '単価は整数部7桁,小数以下3桁以内で入力してください'},
  ],
};

const 金額Validator = {
  name: '金額',
  constraints: [
    {method: (value: number) => 小数制限(value, 7, 3), message: '合計金額は整数部7桁,小数以下3桁以内で入力してください'},
  ],
};

const 期限切れ破棄破損Validators: Validator[] = [
  処理日Validator,
  商品コードValidator,
  バラ数Validator,
  単価Validator,
  金額Validator,
];
